(function ($) {
    var numSlick = 0;

    // Video Carousel
    // Overview slider
    $('.video-carousel .slider').each(function () {

        $(this).find('.slider-item:first').addClass('is-selected');


        numSlick++;

        $(this).slick({
            accessibility: false,
            adaptiveHeight: true,
            arrows: true,
            autoplay: false,
            dots: false,
            infinite: false,
            slide: '.slider-item',
            rows: 0,
            slidesToScroll: 1,
            slidesToShow: 3,
            swipe: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });

        $(this).find('.slider-item').on('click', function (e) {
            e.preventDefault();

            $(this).closest('.video-carousel').find('.slider-item').removeClass('is-selected');
            $(this).addClass('is-selected');

            $(this).closest('.video-carousel').find('.js-vid-carousel-player').attr('src', $(this).find('a').attr('href'));

        });
    });








    var $sliderCTA = $('.slider-cta');
    var sliderCountCTA = '.slider-status-cta .slide-count';

    // Current slide setup
    $sliderCTA.on('init', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $(sliderCountCTA).text(i + ' of ' + slick.slideCount);
    });

    // Slider with CTA cards
    $sliderCTA.each(function () {
        numSlick++;

        $(this).addClass('slider-cta-' + numSlick).slick({
            accessibility: false,
            arrows: false,
            dots: true,
            infinite: true,
            slide: '.slider-item',
            rows: 0,
            slidesToScroll: 1,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        })
            .on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).closest('.cta-block').find(sliderCountCTA).text(i + ' of ' + slick.slideCount);
            });

        // Custom prev/next button setup
        $('.slider-arrows.slide-prev').on('click', function () {
            $(this).closest('.cta-block').find('.slider-cta').slick('slickPrev');
        });
        $('.slider-arrows.slide-next').on('click', function () {
            $(this).closest('.cta-block').find('.slider-cta').slick('slickNext');
        });
    });

    // Sets equal height to each slide
    $(window).load(function () {
        $('.slider-cta').on('setPosition', function () {
            $(this).find('.slick-slide').height('auto');
            var slickTrack = $(this).find('.slick-track');
            var slickTrackHeight = $(slickTrack).height();
            $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
        });
    })
    $('.slider-cta').on('setPosition', function (event, slick) {
        $(slick.$slides).height('auto').css('height', $(slick.$slideTrack).height() + 'px');
    });


    // Overview slider
    $('.slider-resources').each(function () {
        numSlick++;

        //console.log($(this));

        $(this).addClass('slider-resources-' + numSlick).slick({
            accessibility: false,
            adaptiveHeight: true,
            arrows: true,
            dots: false,
            infinite: false,
            slide: 'article',
            rows: 0,
            slidesToScroll: 1,
            slidesToShow: 3,
            swipe: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });
    });


    // Slider with scrolling slides
    $('.slider-logos').each(function () {
        numSlick++;

        $(this).addClass('slider-logos-' + numSlick).slick({
            accessibility: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            dots: false,
            infinite: true,
            slide: '.slider-item',
            rows: 0,
            slidesToScroll: 1,
            slidesToShow: 7,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
    });


    // Overview slider
    $('.slider-overview').each(function () {
        numSlick++;

        //console.log($(this));

        $(this).addClass('slider-overview-' + numSlick).slick({
            adaptiveHeight: true,
            accessibility: true,
            arrows: true,
            dots: false,
            infinite: false,
            rows: 0,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 1,
            swipe: false,
            prevArrow: '<button type="button" class="slick-prev"><span class="btn-text text-prev">' + $(this).data('prevText') + '</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="btn-text text-next">' + $(this).data('nextText') + '</span></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false
                    }
                },
            ]
        })
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $('.slider-overview .slick-arrow').addClass('is-hidden');
            })
            .on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $('.slider-overview .slick-arrow').removeClass('is-hidden');
            });
    });

    // Swap overview slide on mobile using toggle switch
    $('.slider-toggle-switch #sliderSwitch').change(function () {
        if (this.checked) {
            $('.slider-overview').slick('slickGoTo', 1);
        } else {
            $('.slider-overview').slick('slickGoTo', 0);
        }
    });


    // Swap overview slide on mobile using toggle switch
    $('.slider-toggle-switch #sliderContactSwitch').change(function () {
        if (this.checked) {
            $('.js-contact-job-seekers').addClass('d-none');
            $('.js-contact-businesses').removeClass('d-none');
        } else {
            $('.js-contact-job-seekers').removeClass('d-none');
            $('.js-contact-businesses').addClass('d-none');
        }
    });





    // Feature slider with full width background image
    var $sliderCarousel = $('.slider-feature');
    var sliderCount = '.slider-status .slide-count';

    // Current slide setup
    $sliderCarousel.on('init', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $(sliderCount).text(i + ' of ' + slick.slideCount);
    });

    // Initialize slider
    $sliderCarousel.each(function () {
        $(this).addClass('slider-feature-' + numSlick).slick({
            accessibility: false,
            appendDots: $(this).find(sliderCount),
            arrows: false,
            dots: true,
            fade: true,
            infinite: false,
            slide: '.slider-item',
            rows: 0,
            slidesToScroll: 1,
            slidesToShow: 1,
        })
            .on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).closest('.image-block').find(sliderCount).text(i + ' of ' + slick.slideCount);
            });

        // Custom prev/next button setup
        $('.slider-arrows.slide-prev').on('click', function () {
            $(this).closest('.image-block').find('.slider-feature').slick('slickPrev');
        });
        $('.slider-arrows.slide-next').on('click', function () {
            $(this).closest('.image-block').find('.slider-feature').slick('slickNext');
        });

    });


    // Toggle tabs
    $('.slider-tabs').slick({
        arrows: false,
        asNavFor: '.slider-tabs-nav',
        fade: true,
        slide: '.slider-item',
        rows: 0,
        slidesToScroll: 1,
        slidesToShow: 1,
    });
    $('.slider-tabs-nav').slick({
        arrows: true,
        asNavFor: '.slider-tabs',
        dots: false,
        rows: 0,
        focusOnSelect: true,
        slide: '.nav-item',
        slidesToScroll: 1,
        slidesToShow: 6,
        //variableWidth: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    // Initialize awards slider
    $('.awards-block').each(function () {
        numSlick++;

        let numDesktopSlides = $(this).data('slides');
        let numSlidesArray = [];

        if (numDesktopSlides == 12) {
            numSlidesArray.push(8)
            numSlidesArray.push(6)
            numSlidesArray.push(4)
            numSlidesArray.push(2)
            numSlidesArray.push(2)
        } else {
            numSlidesArray.push(6)
            numSlidesArray.push(4)
            numSlidesArray.push(3)
            numSlidesArray.push(2)
            numSlidesArray.push(1)
        }

        console.log(numSlidesArray)

        $(this).find('.slider').addClass('slider-' + numSlick).slick({
            accessibility: false,
            dots: false,
            rows: 0,
            infinite: true,
            slide: '.slider-item',
            slidesToScroll: 2,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: numSlidesArray[0],
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: numSlidesArray[1],
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: numSlidesArray[2],
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: numSlidesArray[3],
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        dots: true,
                        slidesToShow: numSlidesArray[4],
                    }
                }
            ]

        });

    });


})(jQuery);